import { currentWorld, worlds, type ReadyWorldId } from './worlds'
import { CityIllustration } from './CityIllustration'

export function WorldPicker({selected,onChoose}:{selected:string|undefined;onChoose:(id:ReadyWorldId)=>void}){
  const active=currentWorld(selected)
  return <section className="settings-section world-picker" aria-labelledby="world-picker-title">
    <div className="world-picker-heading"><div><h2 id="world-picker-title">3D worlds</h2><p>Explore a city. More worlds will open as they are built.</p></div><span>{worlds.filter(world=>world.ready).length} of {worlds.length} ready</span></div>
    <div className="world-grid">{worlds.map((world,index)=><button
      key={world.id}
      type="button"
      className={`world-choice ${active.id===world.id?'selected':''}`}
      disabled={!world.ready}
      aria-pressed={world.ready?active.id===world.id:undefined}
      title={world.ready?`Explore ${world.name}`:`${world.name} is coming soon`}
      onClick={()=>world.ready&&onChoose(world.id as ReadyWorldId)}
    ><span className="world-choice-art"><CityIllustration id={world.id}/><span className="world-choice-number">{String(index+1).padStart(2,'0')}</span></span><span className="world-choice-label"><b>{world.name}</b><small>{world.place}</small><span className="world-choice-status">{world.ready?(active.id===world.id?'Selected':'Explore'):'Coming soon'}</span></span></button>)}</div>
  </section>
}
